<template>
  <div>
    <div class="resItem" v-for="(item, index) in list" :key="index">
      <div class="ltitle">{{ item.caseName }}</div>
      <div>{{ item.createTime }}</div>
      <div>
        <a-button type="primary" class="mr10" @click="check(item)">查看</a-button>
        <a-button type="danger" @click="change(item)">修改</a-button>
      </div>
    </div>
    <div class="submit">
      <a-button type="primary" @click="handleAddMedical()">新增病例</a-button>
    </div>

    <!-- 新增 修改对话框 -->
    <a-modal
      v-model="dialogVisible"
      :title="dialogTitle"
      :cancelText="cancelText"
      :okText="okText"
      @ok="handleOk"
    >
      <template slot="footer">
        <div>
          <a-button v-if="footer" key="back" @click="handleCancel">
            {{ cancelText }}
          </a-button>
          <a-button v-if="footer" key="submit" type="primary" @click="handleOk">
            {{  okText }}
          </a-button>
        </div>
      </template>
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-item label="疾病名称">
          <a-input
            v-decorator="['caseName', { rules: [{ required: true, message: '请输入疾病名称' }] }]"
          />
        </a-form-item>
        <a-form-item label="疾病描述">
          <mTextarea
            v-model="form.caseDesc"
            type="textarea" 
            :maxLength="200"
            placeholder="疾病描述"
            :rows="4"
            v-decorator="['caseDesc', { rules: [{ required: true, message: '请输入疾病描述' }] }]"
            :showWordLimit="true"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import mTextarea from './components/m-textarea.vue'
import { getRecordList, saveRecord } from '@/api/user-center'
  export default {
    components: {
      mTextarea
    },
    data() {
      return  {
        list: [],
        dialogVisible: false,
        dialogTitle: '新增病例',
        form: this.$form.createForm(this),
        okText: '提交',
        cancelText: '取消',
        footer: true,
        recordId: ''
      }
    },
    created() {
      this.getList()
    },
    methods: {
      // 获取列表 业务类型(1:自建病例,2:自建检测)
      async getList() {
        const res = await getRecordList(1)
        if (res.code == 200) {
          this.list = res.data;
        }
      },

      // 新增病例
      handleAddMedical() {
        this.recordId = ''
        this.resetDialog(1, '新增病例', '取消', true)
        this.backfill({
          caseName: '',
          caseDesc: ''
        })
      },

      // 查看
      check(item) {
        this.resetDialog(0, '查看病例', '放弃修改', true)
        this.backfill(item)
      },

      // 回填默认数据
      backfill(item) {
        setTimeout(() => {
          this.form.setFieldsValue({
            caseName: item.caseName,
            caseDesc: item.caseDesc
          })
          Object.assign(this.form, item)
        })
      },

      /**
       * @description 统一弹窗
       * @params footer：是否需要底部按钮 dialogTitle：弹窗标题 
       * @params cancelText：取消按钮文案 dialogVisible：是否显示
       * @author grantguo
       * @date 2023-06-12 15:42:52
      */
      resetDialog(footer, dialogTitle, cancelText, dialogVisible) {
        Object.assign(this, {
          footer,
          dialogTitle,
          cancelText,
          dialogVisible
        })
      },

      // 修改
      change(item) {
        this.recordId = item.id
        this.resetDialog(1, '修改病例', '放弃修改', true)
        this.backfill(item)
      },

      // 提交
      handleOk() {
        this.form.validateFields(async (err, values) => {
          if (!err) {
            const params = {
              id: this.recordId,
              caseType: 1,
              ...values
            }
            const res = await saveRecord(params)
            if(res.code == 200) {
              this.$message.success('提交成功');
              this.dialogVisible = false
              this.getList()
            } else {
              this.$message.warning(`${res.message}`);
            }
          }
        })
      },

      //取消
      handleCancel() {
        this.dialogVisible = false
      }
    }
  }
</script>
<style lang="less" scoped>
.mr10 {
  margin-right: 10px;
}
.title {
  font-size: 18px;
  color: #333;
}
.resItem {
  display: flex;
  align-items: center;
  width: 955px;
  height: 53px;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px 0px rgba(71,133,230,0.25);
  border-radius: 5px;
  justify-content: space-between;
  padding: 0 40px;
  margin: 0 auto 30px;
}

.submit {
  margin: 20px 0 0;
  text-align: center;
}
</style>

